export default __webpack_public_path__ + "static/media/logo-colored.7b6499f3.png";